// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"NS","fixed":"OS","nonLayerdFacets":"PS","productCount":"QS","facetBack":"RS","arrow":"SS"};